export default "__VITE_ASSET__Ci2NxxT1__"